<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="row">
    <div class="col-6">
      <div class="business-dropdown-group">
        <businesses-dropdown />
      </div>
    </div>
    <div class="col-6 user-name">
      <div data-test="userName">
        {{ $t('common.welcome', { userName: userName }) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BusinessesDropdown from '@/app/global/components/BusinessesDropdown.vue';

export default {
  name: 'DesktopHeader',
  components: {
    BusinessesDropdown,
  },
  computed: {
    ...mapGetters({
      userName: 'user/displayName',
    }),
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout', {
        auth: this.$auth,
        redirect: window.location.origin,
      });
    },
    navigateToProfile() {
      this.$router.push({ name: 'profile' });
    },
  },
};
</script>

<style scoped lang="scss">
.business-dropdown-group {
  width: 100%;
  @media screen and (min-width: 768px) {
    max-width: 350px;
  }
}
.user-name {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
  position: relative;
  text-align: right;
  @media (max-width: 992px) {
    display: none;
  }
}
</style>
